import React from 'react';
import { Users, Shield, Database, Key } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface OpenLDAPFeatureCardProps {
  title: string;
  description: string;
}

const iconMap: Record<string, LucideIcon> = {
  'Centralized Directory': Users,
  'Advanced Security': Shield,
  'High Availability': Database,
  'Identity Management': Key,
  // French translations
  'Annuaire Centralisé': Users,
  'Sécurité Avancée': Shield,
  'Haute Disponibilité': Database,
  'Gestion des Identités': Key,
};

const OpenLDAPFeatureCard: React.FC<OpenLDAPFeatureCardProps> = ({ 
  title, 
  description 
}) => {
  const Icon = iconMap[title] || Users;

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 border border-gray-100">
      <div className="flex items-center mb-4">
        <div className="bg-blue-100 rounded-full p-2">
          <Icon className="h-6 w-6 text-blue-600" />
        </div>
      </div>
      <h4 className="text-lg font-semibold text-gray-900 mb-2">{title}</h4>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

export default OpenLDAPFeatureCard;